import React from 'react';
import { Form, Field } from 'react-final-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap';

import { renderField, required, number, positiveNumber } from '../../../forms';
import TextEditor from './TextEditor';

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    {label && <ControlLabel>{label}</ControlLabel>}
    <FormControl {...input} type={type} />
  </InputGroup>
);

const HotelRoomPrefsForm = ({ onSubmit, initialValues }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={values => {
      const errors = {};
      if (!values.suites && !values.kings && !values.queens) {
        errors.FORM_ERROR = 'At least one room is required';
      }
      if (values.suites) {
        if (isNaN(values.suites)) {
          errors.suites = 'Must be a number';
        } else if (values.suites < 0) {
          errors.suites = 'Must be a postive number';
        }
      }
      if (values.kings) {
        if (isNaN(values.kings)) {
          errors.kings = 'Must be a number';
        } else if (values.kings < 0) {
          errors.kings = 'Must be a postive number';
        }
      }
      if (values.queens) {
        if (isNaN(values.queens)) {
          errors.queens = 'Must be a number';
        } else if (values.queens < 0) {
          errors.queens = 'Must be a postive number';
        }
      }
      return errors;
    }}
    render={({ handleSubmit, reset, submitting, pristine, errors }) => (
      <form onSubmit={handleSubmit}>
        <div className="col-sm-10">
          <FormGroup>
            <Field
              name="note_json"
              type="textarea"
              component={TextEditor}
              label="Bid Details"
              placeholder="Lodging requests for this group. This note will be included in all tour stops."
            />
            <HelpBlock>
              Lodging requests for this group. This note will be included in all tour stops.
            </HelpBlock>
          </FormGroup>
        </div>
        <div className="col-sm-3">
          <FormGroup>
            <Field
              name="suites"
              type="text"
              component={renderBootstrapField}
              label="Suites"
              placeholder="#"
            />
          </FormGroup>
        </div>
        <div className="col-sm-3">
          <FormGroup>
            <Field name="kings" component={renderBootstrapField} label="Kings" />
          </FormGroup>
        </div>
        <div className="col-sm-3">
          <FormGroup>
            <Field name="queens" component={renderBootstrapField} label="Doubles" />
          </FormGroup>
        </div>
        <div className="col-sm-9">
          {errors.FORM_ERROR && <p className="alert alert-danger">{errors.FORM_ERROR}</p>}
          {errors.suites && <p className="alert alert-danger">{errors.suites}</p>}
          {errors.kings && <p className="alert alert-danger">{errors.kings}</p>}
          {errors.queens && <p className="alert alert-danger">{errors.queens}</p>}
          <FormGroup>
            <ButtonToolbar>
              <Button disabled={pristine || submitting} bsStyle="success" type="submit">
                <i className="fa fa-pencil fa-lg" /> Save
              </Button>
            </ButtonToolbar>
          </FormGroup>
        </div>
      </form>
    )}
  />
);

export default HotelRoomPrefsForm;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelRoomPrefsForm.js